<div class="menuHamburger">
    <button
        mat-icon-button
        (click)="toggle()">
        <mat-icon
            mat-list-icon
            class="icone-menu-hamburguer"
            [svgIcon]="toggleMenu ? 'close' : 'menu'">
        </mat-icon>
    </button>
</div>
